import { jsx as _jsx } from "react/jsx-runtime";
import { resolveWidth } from '../consts.js';
import './Component_SL_Text.scss';
import { _className } from '@nu-art/thunderstorm-frontend';
export const Component_SL_Text = (p) => {
    const className = _className('csl-text', p.variant ?? 'normal');
    if (p.text) {
        return _jsx("div", { className: className, children: p.text });
    }
    const resolvedWidth = resolveWidth(p.width ?? 150, [100, 200]);
    const height = p.height ?? 7;
    return _jsx("div", { className: className, style: { width: resolvedWidth, height } });
};
//# sourceMappingURL=Component_SL_Text.js.map